import React, { useState, useEffect } from "react";
import {
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  FormGroup,
  Label,
  Input,
  FormText,
  Form,
  Alert,
  Spinner,
} from "reactstrap";
const LoadFromFile = ({ newAssetFromFile }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [file, setFile] = useState({});
  const [warnings, setWarnings] = useState([]);
  const [errors, setErrors] = useState([]);
  const [newAssetId, setNewAssetId] = useState(-1);
  const saveAndContinue = () => {
    setLoading(true);

    newAssetFromFile(file)
      .then((r) => {
        const w = r.response.Warning;
        setWarnings(w.split(";").filter((i) => i.length > 0));

        if (r.response.result.Code != 200) {
          const e = r.response.result.Description;
          setErrors(e.split(";").filter((i) => i.length > 0));
        } else {
          setNewAssetId(r.response.assetId);
        }
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    setWarnings([]);
    setErrors([]);
    setNewAssetId(-1);
  }, [isOpen]);

  const handleFileInput = (event) => {
    setWarnings([]);
    setErrors([]);
    setNewAssetId(-1);

    const file = event.target.files[0];
    const name = file.name.substring(0, file.name.indexOf("."));
    const extension = file.name.substring(file.name.indexOf(".") + 1, file.name.length);
    if (file.size <= 5242880) {
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () => {
        const fileBlob = reader.result.split(",")[1];
        setFile({
          //id: Math.random().toString(36).substring(7),
          blob: fileBlob,
          extension,
          name,
        });
      };
      reader.onerror = (error) => {
        throw error;
      };
    } else {
      alert("File is too big! (Max. 5MB)");
      event.target = "";
    }
  };

  const goToAsset = (assetId) => {
    window.location.href = window.location.href + "/" + assetId;
    window.location.reload();
  };

  return (
    <div>
      <Button color="primary" onClick={() => setIsOpen(true)}>
        Load from XLS
      </Button>
      <Modal fullscreen="xl" size="lg" toggle={() => setIsOpen(false)} isOpen={isOpen}>
        <ModalHeader toggle={() => setIsOpen(false)}>Load asset from XLS</ModalHeader>
        <ModalBody>
          <Form>
            <FormGroup>
              <Label for="exampleFile">File</Label>
              <Input
                id="exampleFile"
                name="file"
                type="file"
                onChange={handleFileInput}
                accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                                        application/vnd.ms-excel.sheet.binary.macroEnabled.12,
                                        application/vnd.ms-excel,
                                        application/vnd.ms-excel.sheet.macroEnabled.12"
              />
              <FormText>The file extension must be xls, xlsx or xlsm.</FormText>
            </FormGroup>
          </Form>

          {newAssetId >= 0 && (
            <Alert>
              <h4 className="alert-heading">Asset added succesfully!</h4>
              <p>Click on "Go to Asset" to view the new asset details.</p>
            </Alert>
          )}

          {errors.length > 0 && (
            <Alert color="danger">
              <h4 className="alert-heading">Errors</h4>
              <p>Some fields are missing or unformatted. The asset cannot be created.</p>

              <ul>
                {errors.map((w) => (
                  <li>{w} </li>
                ))}
              </ul>
            </Alert>
          )}

          {warnings.length > 0 && (
            <Alert color="warning">
              <h4 className="alert-heading">Warnings</h4>
              <ul>
                {warnings.map((w) => (
                  <li>{w} </li>
                ))}
              </ul>
            </Alert>
          )}
        </ModalBody>
        <ModalFooter>
          {loading && (
            <Spinner color="primary" size="sm">
              Loading...
            </Spinner>
          )}
          {newAssetId >= 0 ? (
            <a href={"./#/asset/" + newAssetId}>
              <Button
                onClick={() => {
                  goToAsset(newAssetId);
                }}
                color="success"
              >
                {" "}
                Go to asset{" "}
              </Button>
            </a>
          ) : (
            <Button color="primary" onClick={saveAndContinue} disabled={!file.blob || loading}>
              Save and Continue
            </Button>
          )}{" "}
          <Button onClick={() => setIsOpen(false)}>Cancel</Button>
        </ModalFooter>
      </Modal>
    </div>
  );
};

export default LoadFromFile;
